var map = {
	"./autoplay-defined-strategy.js": [
		8384,
		9,
		[
			182,
			33
		]
	],
	"./benefits-cards.js": [
		7231,
		9,
		[
			182,
			760
		]
	],
	"./catalog.js": [
		3834,
		9,
		[
			182,
			523
		]
	],
	"./clickable-block.js": [
		5041,
		9,
		[
			538
		]
	],
	"./contact.js": [
		221,
		9,
		[
			182,
			62
		]
	],
	"./defined-strategy.js": [
		1792,
		9,
		[
			182,
			905
		]
	],
	"./filters-news.js": [
		2124,
		9,
		[
			182,
			213
		]
	],
	"./footer.js": [
		1558,
		9,
		[
			182,
			967
		]
	],
	"./front-page-header.js": [
		5776,
		9,
		[
			182,
			305
		]
	],
	"./header.js": [
		2352,
		9,
		[
			513
		]
	],
	"./infoblock-with-pattern.js": [
		7274,
		9,
		[
			182,
			627
		]
	],
	"./infoblock.js": [
		6452,
		9,
		[
			182,
			533
		]
	],
	"./investments-slider.js": [
		8805,
		9,
		[
			182,
			206
		]
	],
	"./investments.js": [
		4811,
		9,
		[
			182,
			436
		]
	],
	"./key-numbers.js": [
		9085,
		9,
		[
			182,
			886
		]
	],
	"./latest-news.js": [
		608,
		9,
		[
			182,
			401
		]
	],
	"./page-header-banner.js": [
		2509,
		9,
		[
			182,
			342
		]
	],
	"./page-header-narrow.js": [
		4632,
		9,
		[
			182,
			297
		]
	],
	"./page-header-without-banner.js": [
		6746,
		9,
		[
			182,
			139
		]
	],
	"./quick-link.js": [
		5375,
		9,
		[
			182,
			352
		]
	],
	"./sectors-cards.js": [
		8468,
		9,
		[
			182,
			229
		]
	],
	"./services-slider.js": [
		2479,
		9,
		[
			182,
			48
		]
	],
	"./short-news.js": [
		8367,
		9,
		[
			672
		]
	],
	"./single-posts-nav.js": [
		619,
		7,
		[
			516
		]
	],
	"./skip-link.js": [
		1307,
		7,
		[
			788
		]
	],
	"./team-slider.js": [
		8316,
		9,
		[
			182,
			877
		]
	],
	"./team.js": [
		7992,
		9,
		[
			182,
			9
		]
	],
	"./value-pillars.js": [
		848,
		9,
		[
			182,
			390
		]
	],
	"./video-pack.js": [
		8174,
		9,
		[
			182,
			799
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[2].map(__webpack_require__.e)).then(function() { return __webpack_require__.t(id, ids[1] | 16); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2056;
module.exports = webpackAsyncContext;